import { api } from "@/lib/api";

/** Fire-and-forget impression/click tracking for a sponsor placement. Never
 * blocks or surfaces errors to the visitor. */
export function trackAdvertiser(advertiserId, event) {
  if (!advertiserId) return;
  api.post(`/public/advertisers/${advertiserId}/track`, { event }).catch(() => {});
}
